import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { IoClose } from 'react-icons/io5';

const TrackOrderModal = ({ isOpen, onClose }) => {
  const [query, setQuery] = useState('');
  const [result, setResult] = useState(null);
  const [searched, setSearched] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    const cleanQuery = query.trim().toUpperCase();
    const orders = JSON.parse(localStorage.getItem('mitoforge_shiprocket_orders') || '[]');
    const match = orders.find((o) =>
      o.order_id.toUpperCase() === cleanQuery ||
      o.awb_tracking.toUpperCase() === cleanQuery ||
      (o.customer && o.customer.phone && o.customer.phone.includes(cleanQuery))
    );

    setSearched(true);
    setResult(match || null);
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0, 0, 0, 0.92)',
          backdropFilter: 'blur(20px)',
          zIndex: 4000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px'
        }}
      >
        <motion.div
          initial={{ scale: 0.94, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.94, opacity: 0 }}
          style={{
            background: '#0a0a0a',
            width: '100%',
            maxWidth: '580px',
            borderRadius: '12px',
            border: '1px solid #333333',
            padding: '36px',
            position: 'relative',
            boxShadow: '0 25px 80px rgba(0, 0, 0, 0.9)'
          }}
        >
          <button
            onClick={onClose}
            style={{ position: 'absolute', top: '24px', right: '24px', color: '#888888' }}
          >
            <IoClose size={26} />
          </button>

          <div style={{ textAlign: 'center', marginBottom: '28px' }}>
            <span style={{ fontSize: '2.4rem' }}>🛰️</span>
            <h2 style={{ color: '#ffffff', fontSize: '1.5rem', marginTop: '8px', fontWeight: 900 }}>Shiprocket Live Manifest</h2>
            <p style={{ color: '#888888', fontSize: '0.88rem', marginTop: '6px' }}>
              Enter Order ID (#MF-XXXX), AWB (#SR-XXXX), or mobile number to trace priority air dispatch.
            </p>
          </div>

          <form onSubmit={handleSearch} style={{ display: 'flex', gap: '12px', marginBottom: '28px' }}>
            <input
              type="text"
              required
              placeholder="e.g. MF-89421 or SR-10293847 or 9876543210"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              style={{
                flex: 1,
                padding: '14px 18px',
                background: '#121212',
                border: '1px solid #333333',
                borderRadius: '6px',
                color: '#ffffff',
                fontSize: '0.92rem',
                outline: 'none',
                fontFamily: 'monospace'
              }}
            />
            <button
              type="submit"
              style={{
                padding: '14px 24px',
                background: '#ffffff',
                color: '#000000',
                fontWeight: 800,
                borderRadius: '6px',
                textTransform: 'uppercase',
                border: 'none',
                cursor: 'pointer',
                fontSize: '0.85rem'
              }}
            >
              Scan →
            </button>
          </form>

          {searched && result && (
            <div style={{ borderTop: '1px solid #222222', paddingTop: '24px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <div>
                  <div style={{ color: '#ffffff', fontWeight: 900, fontSize: '1.05rem', fontFamily: 'monospace' }}>
                    STATUS: {result.status}
                  </div>
                  <div style={{ color: '#888888', fontSize: '0.82rem', marginTop: '2px' }}>
                    AWB: #{result.awb_tracking} · Courier: BlueDart Priority Air
                  </div>
                </div>
                <span style={{ background: '#1c1c1c', border: '1px solid #444444', color: '#ffffff', padding: '6px 12px', borderRadius: '4px', fontSize: '0.72rem', fontWeight: 700 }}>
                  Active Dispatch
                </span>
              </div>

              <div style={{ background: '#121212', border: '1px solid #282828', borderRadius: '8px', padding: '16px', fontSize: '0.88rem', color: '#cccccc' }}>
                <p style={{ margin: '0 0 6px 0', color: '#ffffff' }}>
                  <strong>Receiver:</strong> {result.customer.name} ({result.customer.phone})
                </p>
                <p style={{ margin: '0 0 6px 0' }}>
                  <strong>Destination:</strong> {result.customer.address}, {result.customer.city}, {result.customer.state} - {result.customer.pincode}
                </p>
                <p style={{ margin: '0', color: '#888888' }}>
                  <strong>Payment:</strong> {result.payment_method} ({result.payment_id})
                </p>
              </div>
            </div>
          )}

          {searched && !result && (
            <div style={{ borderTop: '1px solid #222222', paddingTop: '24px', textAlign: 'center' }}>
              <div style={{ color: '#ffffff', fontWeight: 800, marginBottom: '6px' }}>
                SIMULATION STATUS: IN TRANSIT (PRIORITY AIR)
              </div>
              <p style={{ color: '#888888', fontSize: '0.88rem' }}>
                No local browser cache matched "{query}". Shiprocket air manifests synchronize every 15 minutes.
              </p>
            </div>
          )}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default TrackOrderModal;
